export * from './queries';

export const eventKeys = {
  allEvents: (locale: string) => ['events', locale],
  eventById: (locale: string, eventId: string) => ['event', locale, eventId],
};
